import { styled } from "styled-components";
import { Card } from "styles/mixinStyles";

const EmptyGuideBoxContainer = styled(Card)`
  width: 90vw;
  height: 30vw;
  flex-direction: column;
  h2 {
    font-weight: 800;
  }
`;

export { EmptyGuideBoxContainer };

